import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IFrameDialogData } from '../models/iframe-dialog-data.model';
import { CommonModule } from '@angular/common';
import { ButtonLegacyModule, IconModule } from 'studio-components';

/**
 * An iframe component with support for passing MAT_DIALOG_DATA
 * so that it can be used within a dialog popup.
 */
@Component({
  selector: 'studio-iframe-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatDialogModule, ButtonLegacyModule, IconModule],
  templateUrl: './iframe-dialog.component.html',
  styleUrls: ['./iframe-dialog.component.scss'],
})
export class IFrameDialogComponent {
  public trustedSrc: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<IFrameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) dialogData?: IFrameDialogData,
  ) {
    if (dialogData.src) {
      this.trustedSrc = this.sanitizer.bypassSecurityTrustResourceUrl(dialogData.src);
    }
  }

  public close() {
    this.dialogRef.close();
  }
}
